import type { IconComponent } from './icon'

export const X: IconComponent = ({ className }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <title>X</title>
            <path
                d="M17.1761 4H19.9362L13.9061 10.7774L21 20H15.4455L11.0952 14.4066L6.11723 20H3.35544L9.80518 12.7508L3 4H8.69546L12.6279 9.11261L17.1761 4ZM16.2073 18.3753H17.7367L7.86442 5.53928H6.2232L16.2073 18.3753Z"
                fill="white"
            />
        </svg>
    )
}
